import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Modal } from 'components';
import { GovernmentCharges } from 'scenes/common/types';
import {
  toCurrencyWithSign,
  TWO_DECIMAL_PLACES,
} from 'scenes/common/helpers/currency';
import GovernmentChargeItem from './GovernmentChargeItem/GovernmentChargeItem';

const Table = styled.table`
  width: 100%;
  td,
  th {
    padding: 1px 10px;
    border-left: 1px solid #E9E9E9;
    font-size: 16px;
  }

  td[scope],
  th[scope] {
    font-weight: 700;
  }

  td: first-child, th: first-child {
    padding-left: 0;
    border-left: none;
  }
`;

export const shouldDisplayGovernmentCharge = (
  monthCost: number,
  yearCost: number
): boolean => monthCost > 0 && yearCost > 0;

export const GovernmentChargesModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
  monthlyGovernmentCharges: GovernmentCharges;
  yearlyGovernmentCharges: GovernmentCharges;
}> = ({
  isOpen,
  onClose,
  monthlyGovernmentCharges,
  yearlyGovernmentCharges,
}) => (
  <Modal header="Government Charges" isOpen={isOpen} onClose={onClose}>
    <Table>
      <tbody>
        <tr>
          <th id="paying" scope="row">
            Paying
          </th>
          <th id="annual" scope="col">
            Annual
          </th>
          <th id="monthly" scope="col">
            Monthly
          </th>
        </tr>
        {shouldDisplayGovernmentCharge(
          monthlyGovernmentCharges.gst,
          yearlyGovernmentCharges.gst
        ) && (
          <GovernmentChargeItem
            heading="GST"
            id="GST"
            monthCost={toCurrencyWithSign(
              monthlyGovernmentCharges.gst,
              TWO_DECIMAL_PLACES
            )}
            yearCost={toCurrencyWithSign(
              yearlyGovernmentCharges.gst,
              TWO_DECIMAL_PLACES
            )}
          />
        )}
        {shouldDisplayGovernmentCharge(
          monthlyGovernmentCharges.fireServicesLevy,
          yearlyGovernmentCharges.fireServicesLevy
        ) && (
          <GovernmentChargeItem
            heading="Fire/Emergency Services levy"
            id="fireService"
            monthCost={toCurrencyWithSign(
              monthlyGovernmentCharges.fireServicesLevy,
              TWO_DECIMAL_PLACES
            )}
            yearCost={toCurrencyWithSign(
              yearlyGovernmentCharges.fireServicesLevy,
              TWO_DECIMAL_PLACES
            )}
          />
        )}
        <GovernmentChargeItem
          heading="Stamp Duty"
          id="stampDuty"
          monthCost={toCurrencyWithSign(
            monthlyGovernmentCharges.stampDuty,
            TWO_DECIMAL_PLACES
          )}
          yearCost={toCurrencyWithSign(
            yearlyGovernmentCharges.stampDuty,
            TWO_DECIMAL_PLACES
          )}
        />
      </tbody>
    </Table>
  </Modal>
);

export default GovernmentChargesModal;
